import {DropdownSelectData, InputDropdownSelectValue} from "app/Interface/Component/Form"
import {DropdownSelectLanguageParam} from "app/Interface/Header/Language"
import useAuthStore, {subscribeAuth} from "app/Service/Auth/AuthService"
import EnvironmentService, {subscribeEnv} from "app/Service/System/EnvironmentService"
import InputDropdownSticky from "app/WebController/Component/Form/InputDropdownSticky"
import Logger from "logger/logger"
import React, {useEffect, useState} from "react"

function AuthLanguageSelect() {
  const {setLanguage, language} = EnvironmentService([
    subscribeEnv.language
  ], 'AuthLanguageSelect')

  const {isAuthenticated} = useAuthStore([
    subscribeAuth.isAuthenticated
  ], 'AuthLanguageSelect')

  const [languageOptions, setLanguageOptions] = useState<DropdownSelectData[]>([])

  useEffect(() => {
    Logger('Element.AuthLanguageSelect.init')
    return () => {
      Logger('Element.AuthLanguageSelect.unloading')
    }
  }, [])

  useEffect(() => {
    setLanguageOptions([
      {
        id: "eng",
        name: "English",
        active: language === "eng"
      }, {
        id: "nld",
        name: "Dutch",
        active: language === "nld"
      }
    ])
  }, [language])

  function changeLanguage(option: InputDropdownSelectValue) {
    const e = {...option} as DropdownSelectLanguageParam
    setLanguage(e.id)
  }

  return isAuthenticated || undefined === language ? null : (
    <InputDropdownSticky
      id={'language-select'}
      options={languageOptions}
      onChange={changeLanguage}
    />
  )
}

export default AuthLanguageSelect
